module.exports = ".pricing-list-details-container {\n\n}\n\n.pricing-list-details-container .price-list-types {\n    padding-top: 20px;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/agora/components/pricing-data/pricing-list/pricing-list-details/pricing-list-details.component.css
// module id = ./src/app/agora/components/pricing-data/pricing-list/pricing-list-details/pricing-list-details.component.css
// module chunks = main